import {Component, type ErrorInfo, type ReactNode} from 'react';
import {logErrorBoundary} from '../../../utils/loggerHelpers';

interface CallSurfaceBoundaryProps {
    readonly resetKey: string;
    readonly children: ReactNode;
}

interface CallSurfaceBoundaryState {
    readonly failed: boolean;
    readonly resetKey: string;
}

export class CallSurfaceBoundary extends Component<CallSurfaceBoundaryProps, CallSurfaceBoundaryState> {
    state: CallSurfaceBoundaryState = {failed: false, resetKey: this.props.resetKey};

    static getDerivedStateFromError(): Partial<CallSurfaceBoundaryState> {
        return {failed: true};
    }

    static getDerivedStateFromProps(props: CallSurfaceBoundaryProps, state: CallSurfaceBoundaryState): Partial<CallSurfaceBoundaryState> | null {
        return props.resetKey === state.resetKey ? null : {failed: false, resetKey: props.resetKey};
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        logErrorBoundary(error, info, 'CallSurface');
    }

    render() {
        return this.state.failed ? null : this.props.children;
    }
}
